import React from "react";
import HomeWithMap from "./pages/HomeWithMap";
import Category from "./pages/Category";
import Product from "./pages/Product";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import Header from "./pages/Layout/Header";
import Register from "./pages/Auth/Register";
import Verify from "./pages/Auth/Verify";
import Login from "./pages/Auth/Login";
import Dashboard from "./pages/Dashboard/Dashboard";
import Search from "./pages/Search";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import Terms from "./pages/Terms";
import Faq from "./pages/Faq";
import About from "./pages/About";
import Request from "./pages/Request";
import Contact from "./pages/Contact";
import Career from "./pages/Career";
import ResetPassword from "./pages/Auth/ResetPassword";
import DealerAdverts from "./pages/DealerAdverts";
import Remove from "./pages/Remove";
import Qr from "./pages/Qr";
import RegisterWithMap from "./pages/Auth/RegisterWithMap";
import Mechanics from "./pages/Mechanics";
import TowTrucks from "./pages/TowTrucks";
import MechanicDetailed from "./pages/MechanicDetailed";
import TowTruckDetailed from "./pages/TowTruckDetailed";
import AdminExport from "./pages/AdminExport";
import Blog from "./pages/Blog";
import BlogDetailed from "./pages/BlogDetailed";

function App(props) {
  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);
  return (
    <BrowserRouter>
      <Header categories />
      <Routes>
        <Route path="/" element={<HomeWithMap />} />
        <Route path="/category/:category/:id" element={<Category />} />
        <Route
          path="/dealer-adverts/:dealer_id/:dealer_name"
          element={<DealerAdverts />}
        />
        <Route
          path="/dealer/:dealer_id/:dealer_name"
          element={<DealerAdverts />}
        />
        <Route path="/advert/:id" element={<Product />} />
        <Route path="/advert/:title/:id" element={<Product />} />
        <Route path="/login" element={<Login />} />
        <Route path="/registerold" element={<Register />} />
        <Route path="/register" element={<RegisterWithMap />} />
        <Route path="/forgot_password" element={<ForgotPassword />} />
        <Route path="/password_reset/:token" element={<ResetPassword />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/active-listing" element={<Dashboard />} />
        <Route path="/inactive-listing" element={<Dashboard />} />
        <Route path="/all-listing" element={<Dashboard />} />
        <Route path="/wishlist" element={<Dashboard />} />
        <Route path="/create-advert" element={<Dashboard />} />
        <Route path="/part-requests" element={<Dashboard />} />
        <Route path="/listing" element={<Dashboard />} />
        <Route path="/update-profile" element={<Dashboard />} />
        <Route path="/dashboard/advert/:item_id" element={<Dashboard />} />
        <Route path="/dashboard/enquiry/:enquiry" element={<Dashboard />} />
        <Route path="/dashboard/edit-advert/:edit_id" element={<Dashboard />} />
        <Route path="/search" element={<Search />} />
        <Route path="/terms-of-services" element={<Terms />} />
        <Route path="/privacy-policy" element={<Terms />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/about" element={<About />} />
        <Route path="/part-request" element={<Request />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/career" element={<Career />} />
        <Route path="/request" element={<Request />} />
        <Route path="/remove_data" element={<Remove />} />
        <Route path="/verify/:token" element={<Verify />} />
        <Route path="/app_redirect" element={<Qr />} />
        <Route path="/mechanics" element={<Mechanics />} />
        <Route path="/towtrucks" element={<TowTrucks />} />
        <Route path="/mechanic/:id" element={<MechanicDetailed />} />
        <Route path="/tow-truck/:id" element={<TowTruckDetailed />} />
        <Route path="/admin-export" element={<AdminExport />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<BlogDetailed />} />

      </Routes>
    </BrowserRouter>
  );
}

export default App;
